import React, { useState } from 'react';
import './ScreenPreview.css';
import { previewAppLogo } from './previewAppLogo';
import { showsSuitestream, canShowActivity } from './screenPreviewTarget';

export default function ScreenPreview({ nowPlaying, target, preview }) {
  const artwork = showsSuitestream(nowPlaying) ? nowPlaying.artworkUrl : null;
  const src = artwork || preview?.dataUrl;
  const [failedSrc, setFailedSrc] = useState(null);
  const [failedLogo, setFailedLogo] = useState(null);
  const logo = canShowActivity(nowPlaying) && !showsSuitestream(nowPlaying) ? previewAppLogo(nowPlaying.activity) : null;
  const showImage = src && failedSrc !== src;
  const title = canShowActivity(nowPlaying) ? (nowPlaying.activity?.home || nowPlaying.activity?.inputSelector
    ? nowPlaying.activity.title : nowPlaying.activity?.appName || nowPlaying.activity?.title || nowPlaying.title) : nowPlaying.title;
  const limitation = target.reason || preview?.message || (failedSrc === src && src ? 'Preview unavailable' : '');
  return (
    <figure className={`screen-preview ${artwork ? 'screen-preview--artwork' : ''}`} aria-label="Screen preview">
      <div className={`screen-preview__window${logo ? ' screen-preview__window--app-logo' : ''}`} title={limitation || undefined}>
        {showImage ? <img src={src} alt={artwork ? `${nowPlaying.title} artwork`
          : `Snapshot from ${target.name}${target.unverified ? ' · TV input unverified' : ''}`}
          onError={() => setFailedSrc(src)} /> : <div className="screen-preview__fallback">
          {logo && failedLogo !== logo.id ? <img className="screen-preview__logo" src={logo.src} alt="" aria-hidden="true"
            onError={() => setFailedLogo(logo.id)} /> : null}
          <strong className="screen-preview__app">{title}</strong>
        </div>}
      </div>
      <figcaption>{artwork && showImage ? 'Artwork' : showImage ? <>
        Snapshot · {target.name}{target.unverified ? ' · input unverified' : ''}<br />
        {preview.capturedAt ? new Date(preview.capturedAt).toLocaleTimeString() : 'Capture time unavailable'}
        {limitation ? ' · update unavailable' : ''}
      </> : nowPlaying.screenOff ? 'Display asleep' : limitation ? 'Preview unavailable'
        : preview?.capturing ? 'Updating preview…' : showsSuitestream(nowPlaying) ? 'Suitestream' : 'App preview'}
      </figcaption>
    </figure>
  );
}
